/* ═══════════════════════════════════════════════════════════════════════════
   MOVIMENTO — V. Color Lenses
   Porte vanilla do shared/motion.ts de FG Store, via o movimento.js de Cat's
   Eye. Mesmos valores (vivem em vcl-tokens.css), mesmas regras.

   O princípio: NADA APARECE DO NADA. Toda mudança de estado é gradual.

   Regras técnicas, e elas não são estilo:
   · anima só transform e opacity (as exceções estão documentadas no CSS)
   · `window.addEventListener('scroll')` é BANIDO: IntersectionObserver ou rAF
   · prefers-reduced-motion tem DOIS mecanismos, e o @media do CSS não alcança
     o que é feito aqui em JS. Por isso a checagem explícita.
   · roda igual no protótipo e no tema: nenhuma dependência de Liquid aqui.
   ═══════════════════════════════════════════════════════════════════════════ */
(() => {
  "use strict";
  document.documentElement.classList.remove("no-js");

  const mq = matchMedia("(prefers-reduced-motion: reduce)");
  const reduzido = () => mq.matches;
  const TETO = 8;
  const raiz = getComputedStyle(document.documentElement);
  const ms = (nome) => parseFloat(raiz.getPropertyValue(nome)) || 0;
  const DUR_SLOW = ms("--dur-slow");
  const DUR_FAST = ms("--dur-fast");
  const CASCATA = ms("--cascata");

  /* ── Entrada de seção ────────────────────────────────────────────────────
     Dispara quando o bloco chega na tela, e não repete. O índice é a ordem de
     LEITURA dentro do grupo ([data-grupo]), não a da página: cada dobra
     recomeça a cascata. Teto de 8.

     ⚠️ Tudo que observa o DOM vive em `iniciar(escopo)`, chamada no load E em
     `shopify:section:load`: o editor de tema RE-RENDERIZA a seção editada e o
     HTML novo chega sem observer nenhum (council de 09/09: a manchete sumia
     ao editar). */
  const obsEntrada = new IntersectionObserver((entradas) => {
    entradas.forEach((e) => {
      if (!e.isIntersecting) return;
      e.target.setAttribute("data-visivel", "true");
      obsEntrada.unobserve(e.target);
    });
  }, { threshold: 0.2, rootMargin: "0px 0px -8% 0px" });
  const prepararEntradas = (escopo) => {
    const alvos = escopo.querySelectorAll(".ao-entrar");
    if (reduzido()) { alvos.forEach((el) => el.setAttribute("data-visivel", "true")); return; }
    escopo.querySelectorAll("[data-grupo]").forEach((grupo) => {
      [...grupo.querySelectorAll(".ao-entrar")].forEach((el, i) => el.style.setProperty("--i", Math.min(i, TETO)));
    });
    alvos.forEach((el) => obsEntrada.observe(el));
  };
  prepararEntradas(document);
  // Marca que as entradas ligaram: sem ela, o layout devolve o no-js no load e tudo aparece (29/09/2026, item 12 de Johny).
  window.vclMovimento = true;
  document.addEventListener("shopify:section:load", (e) => { prepararEntradas(e.target); ligarHeroi(); });

  /* ── Cabeçalho: encolher e preencher ─────────────────────────────────────
     Dois estados independentes, e é de propósito (herdado de Cat's Eye):
       · `encolhido`  a barra baixa. Dois limiares (32 desce, 8 sobe), pra não
                      bater no meio quando a rolagem para em cima do limiar.
       · `preenchido` ganha fundo. Só quando o HERÓI sai de trás; sem herói na
                      página (coleção, produto), nasce preenchido. No topo da home
                      ele é transparente (Mateus, 15/09/2026: "na posição 0 ele tem
                      que ficar invisível"); ao rolar, `encolhido` já dá o fundo.
     Sem `scroll` listener: duas sentinelas observadas. */
  var ligarHeroi = () => {};
  const cabecalho = document.querySelector(".cabecalho");
  if (cabecalho) {
    const s1 = document.createElement("div");
    s1.style.cssText = "position:absolute;top:0;height:32px;width:1px;pointer-events:none;";
    const s2 = document.createElement("div");
    s2.style.cssText = "position:absolute;top:0;height:8px;width:1px;pointer-events:none;";
    document.body.prepend(s1, s2);
    let encolhido = false;
    const aplica = () => cabecalho.classList.toggle("encolhido", encolhido);
    new IntersectionObserver(([e]) => { if (!e.isIntersecting) { encolhido = true; aplica(); } }, { threshold: 0 }).observe(s1);
    new IntersectionObserver(([e]) => { if (e.isIntersecting && e.intersectionRatio >= 0.99) { encolhido = false; aplica(); } }, { threshold: [0, 0.99, 1] }).observe(s2);

    // Re-consulta o herói a cada chamada (o editor de tema pode recriá-lo).
    // A mesma sentinela esconde a bola do WhatsApp enquanto o herói está à
    // vista: no celular ela colidia com o CTA (council 09/09).
    let obsHeroi = null;
    var ligarHeroi = () => {
      if (obsHeroi) obsHeroi.disconnect();
      const heroi = document.querySelector(".heroi");
      if (!heroi) { cabecalho.classList.add("preenchido"); document.body.classList.remove("hero-a-vista"); return; }
      obsHeroi = new IntersectionObserver(([e]) => {
        cabecalho.classList.toggle("preenchido", !e.isIntersecting);
        document.body.classList.toggle("hero-a-vista", e.isIntersecting);
      }, { rootMargin: `-${cabecalho.offsetHeight}px 0px 0px 0px`, threshold: 0 });
      obsHeroi.observe(heroi);
    };
    ligarHeroi();
    // 🔄 18/09/2026, Mateus: no topo da home o header é 100% invisível, inclusive com o
    // mouse em cima (saiu o `sob-ponteiro` de FG, que dava fundo no hover).

    // Menu que não cabe ao lado da logo vira o botão de menu (`nav-longa`). Mede o
    // conteúdo da nav contra a metade livre da barra; ResizeObserver, não resize/scroll.
    const barra = cabecalho.querySelector(".cabecalho__barra");
    const nav = cabecalho.querySelector(".nav");
    const marca = cabecalho.querySelector(".marca");
    if (barra && nav && marca && "ResizeObserver" in window) {
      const mede = () => {
        const itens = nav.children;
        if (!itens.length || !nav.offsetParent) return; // sem menu, ou escondida pelo CSS do celular
        // Largura natural = do começo do 1º item ao fim do último (scrollWidth não serve:
        // nunca é menor que a coluna, e com a nav fora do fluxo mede outra coisa).
        const conteudo = itens[itens.length - 1].getBoundingClientRect().right - itens[0].getBoundingClientRect().left;
        const vao = parseFloat(getComputedStyle(barra).columnGap) || 0;
        // Menu em 2ª linha (nav-linha, marcado no servidor): o espaço é a barra inteira, não a metade (29/09/2026).
        const livre = cabecalho.classList.contains("nav-linha") ? barra.clientWidth - vao * 2 : (barra.clientWidth - marca.offsetWidth) / 2 - vao * 2;
        cabecalho.classList.toggle("nav-longa", conteudo > livre);
      };
      // Os três mudam de tamanho sozinhos (fonte que chega depois, SVG da logo): mede de novo.
      const ro = new ResizeObserver(mede);
      [barra, nav, marca].forEach((el) => ro.observe(el));
    }
  }

  /* ── Mega-menu ───────────────────────────────────────────────────────────
     Abre por CLIQUE (FG). A casca desce por máscara, opaca; os itens entram um
     a um a 80% do caminho. TROCA DE SEÇÃO (regra do "e depois" de Mateus): os
     itens da seção atual SAEM em ordem reversa, e só depois entram os da nova;
     a casca não se mexe. A casca tem min-height no CSS pelo mesmo motivo. */
  const mascara = document.querySelector(".painel-mascara");
  const gatilhos = [...document.querySelectorAll("[data-painel]")];
  let secaoAberta = null;
  let trocando = false;

  const itensDe = (secao) => [...secao.querySelectorAll(".painel__item")];
  const mostrar = (secao, esperarCasca) => {
    secao.hidden = false;
    const itens = itensDe(secao);
    itens.forEach((el, i) => {
      el.style.setProperty("--i", Math.min(i, TETO));
      el.style.setProperty("--espera", esperarCasca ? "var(--atraso-conteudo)" : "0ms");
      el.dataset.saindo = "false";
    });
    requestAnimationFrame(() => secao.setAttribute("data-visivel", "true"));
  };
  const esconder = (secao) => new Promise((fim) => {
    const itens = itensDe(secao);
    const n = itens.length;
    itens.forEach((el, i) => { el.style.setProperty("--i-saida", Math.min(n - 1 - i, TETO)); el.dataset.saindo = "true"; });
    secao.removeAttribute("data-visivel");
    const espera = reduzido() ? 0 : DUR_FAST + Math.min(n - 1, TETO) * (CASCATA * 0.66);
    setTimeout(() => { secao.hidden = true; fim(); }, espera);
  });
  const fecharPainel = async () => {
    if (!mascara || !secaoAberta) return;
    gatilhos.forEach((g) => g.setAttribute("aria-expanded", "false"));
    mascara.dataset.aberto = "false";
    cabecalho && cabecalho.classList.remove("com-painel");
    const s = secaoAberta; secaoAberta = null;
    await esconder(s);
  };
  gatilhos.forEach((g) => {
    g.addEventListener("click", async (ev) => {
      ev.preventDefault();
      if (trocando || !mascara) return;
      const alvo = document.getElementById(g.dataset.painel);
      if (!alvo) return;
      if (secaoAberta === alvo) { fecharPainel(); return; }
      trocando = true;
      gatilhos.forEach((x) => x.setAttribute("aria-expanded", String(x === g)));
      if (secaoAberta) {
        await esconder(secaoAberta);
        secaoAberta = alvo;
        mostrar(alvo, false);
      } else {
        secaoAberta = alvo;
        mascara.dataset.aberto = "true";
        cabecalho && cabecalho.classList.add("com-painel");
        mostrar(alvo, true);
      }
      trocando = false;
    });
  });
  document.addEventListener("keydown", (e) => { if (e.key === "Escape") { fecharPainel(); fecharMenu(); } });
  document.addEventListener("click", (e) => {
    if (!e.target.closest(".painel-mascara") && !e.target.closest("[data-painel]")) fecharPainel();
  });

  /* ── Menu mobile ─────────────────────────────────────────────────────────
     Desliza pela esquerda, opaco do primeiro ao último quadro. Os itens entram
     em cascata depois da casca. */
  const menu = document.querySelector(".menu-mobile");
  const abrirMenu = () => {
    if (!menu) return;
    menu.hidden = false;
    [...menu.querySelectorAll(".menu-mobile__item")].forEach((el, i) => el.style.setProperty("--i", Math.min(i, TETO)));
    requestAnimationFrame(() => { menu.dataset.aberto = "true"; }); // a página trava pelo CSS (html:has, G-20)
  };
  const fecharMenu = () => {
    if (!menu || menu.dataset.aberto !== "true") return;
    menu.dataset.aberto = "false";
    setTimeout(() => { menu.hidden = true; }, reduzido() ? 0 : DUR_SLOW);
  };
  document.querySelectorAll("[data-abre-menu]").forEach((b) => b.addEventListener("click", abrirMenu));
  document.querySelectorAll("[data-fecha-menu]").forEach((b) => b.addEventListener("click", fecharMenu));
  /* Grupo: altura animada como o acordeão do FAQ, subitens em cascata pelo CSS.
     O `hidden` sai antes de abrir e volta depois de fechar (sem foco em link escondido). */
  document.querySelectorAll(".menu-mobile__grupo > button").forEach((b) => {
    const grupo = b.parentElement;
    const sub = b.nextElementSibling;
    b.addEventListener("click", () => {
      const abrindo = b.getAttribute("aria-expanded") !== "true";
      b.setAttribute("aria-expanded", String(abrindo));
      if (abrindo) {
        sub.hidden = false;
        [...sub.querySelectorAll("a")].forEach((a, i) => a.style.setProperty("--i", Math.min(i, TETO)));
      }
      if (reduzido()) { grupo.dataset.aberto = String(abrindo); sub.style.height = abrindo ? "auto" : "0px"; sub.hidden = !abrindo; return; }
      const alvo = sub.firstElementChild.offsetHeight;
      sub.style.height = abrindo ? "0px" : alvo + "px";
      requestAnimationFrame(() => requestAnimationFrame(() => {
        grupo.dataset.aberto = String(abrindo);
        sub.style.height = abrindo ? alvo + "px" : "0px";
      }));
      sub.addEventListener("transitionend", function solta(e) {
        if (e.target !== sub || e.propertyName !== "height") return;
        sub.removeEventListener("transitionend", solta);
        if (b.getAttribute("aria-expanded") !== String(abrindo)) return; // clicou de novo no meio
        if (abrindo) sub.style.height = "auto"; else sub.hidden = true;
      });
    });
  });

  /* ── Card: equivalente tocável da troca de foto ──────────────────────────
     Sem hover, os pontos no canto trocam a face. O card inteiro é link, então
     o clique no ponto não pode navegar. */
  document.querySelectorAll(".card__faces").forEach((faces) => {
    faces.querySelectorAll("button").forEach((b) => {
      b.addEventListener("click", (e) => {
        e.preventDefault(); e.stopPropagation();
        const card = b.closest(".card");
        card.dataset.face = b.dataset.face;
        faces.querySelectorAll("button").forEach((x) => x.setAttribute("aria-pressed", String(x === b)));
      });
    });
  });

  /* ── Card: 2ª face sob demanda (29/09/2026, lista de Johny, "imagens pesadas") ──
     O lazy nativo baixava as duas faces juntas (estão no mesmo lugar): ~700 KB a
     mais na home do celular, medido no Lighthouse, pra uma foto que só aparece no
     hover ou no ponto. Agora ela baixa na primeira intenção. Delegado no document
     porque o filtro da coleção troca os cards sem recarregar a página. */
  const acordaFace = (e) => {
    const card = e.target.closest && e.target.closest(".card");
    if (!card) return;
    card.querySelectorAll("img[data-src]").forEach((img) => {
      if (img.dataset.srcset) img.srcset = img.dataset.srcset;
      img.src = img.dataset.src;
      img.removeAttribute("data-src"); img.removeAttribute("data-srcset");
    });
  };
  document.addEventListener("pointerover", acordaFace, { passive: true });
  document.addEventListener("focusin", acordaFace);
  document.addEventListener("touchstart", acordaFace, { passive: true });

  /* ── FAQ: acordeão com altura animada (exceção registrada) ───────────────── */
  document.querySelectorAll(".faq__item").forEach((item) => {
    const botao = item.querySelector(".faq__botao");
    const resposta = item.querySelector(".faq__resposta");
    if (!botao || !resposta) return;
    botao.addEventListener("click", () => {
      const abrindo = item.dataset.aberto !== "true";
      item.dataset.aberto = String(abrindo);
      botao.setAttribute("aria-expanded", String(abrindo));
      if (reduzido()) { resposta.style.height = abrindo ? "auto" : "0px"; return; }
      const alvo = resposta.firstElementChild.offsetHeight;
      resposta.style.height = abrindo ? "0px" : alvo + "px";
      requestAnimationFrame(() => { resposta.style.height = abrindo ? alvo + "px" : "0px"; });
      if (abrindo) {
        resposta.addEventListener("transitionend", function solta(e) {
          if (e.propertyName !== "height") return;
          resposta.style.height = "auto";
          resposta.removeEventListener("transitionend", solta);
        });
      }
    });
  });

  /* ── Barra de anúncio rotativa ───────────────────────────────────────────
     Uma condição por vez. Quem sai vai pra CIMA, quem entra vem de BAIXO.
     Pausa no hover e no foco; `aria-live="polite"` no trilho; com movimento
     reduzido continua trocando, só não desliza. Aba escondida não anima. */
  const trilho = document.querySelector(".anuncio__trilho");
  if (trilho) {
    /* 29/09/2026, Claude: a data da campanha ("· até 31/10") sai quando a linha não cabe. Mede em vez de
       chutar largura: muda com o idioma e com a fonte. Sem listener de scroll, só ResizeObserver. */
    const comData = [...trilho.querySelectorAll(".anuncio__item")].filter((el) => el.querySelector(".anuncio__data"));
    if (comData.length) {
      const medir = () => comData.forEach((el) => { el.dataset.curto = "false"; el.dataset.curto = String(el.scrollWidth > el.clientWidth); });
      medir(); document.fonts?.ready.then(medir);
      new ResizeObserver(medir).observe(trilho);
    }
    const itens = [...trilho.querySelectorAll(".anuncio__item")];
    if (itens.length > 1) {
      let atual = 0, timer = null;
      const INTERVALO = 4200;
      const mostrarItem = (novo) => {
        if (novo === atual) return;
        const sai = itens[atual];
        sai.dataset.saindo = "true"; sai.dataset.ativo = "false";
        setTimeout(() => delete sai.dataset.saindo, 480);
        atual = (novo + itens.length) % itens.length;
        itens[atual].dataset.ativo = "true";
      };
      const proximo = () => mostrarItem(atual + 1);
      // `pausado` é a escolha da pessoa no botão (29/09/2026, item 8 de Johny): hover, foco e aba só seguram por um tempo.
      let pausado = false;
      const parar = () => { if (timer) clearInterval(timer); timer = null; };
      const tocar = () => { parar(); if (!pausado) timer = setInterval(proximo, INTERVALO); };
      const faixa = trilho.closest(".anuncio");
      faixa.addEventListener("mouseenter", parar); faixa.addEventListener("mouseleave", tocar);
      faixa.addEventListener("focusin", parar); faixa.addEventListener("focusout", (e) => { if (!faixa.contains(e.relatedTarget)) tocar(); });
      document.addEventListener("visibilitychange", () => (document.hidden ? parar() : tocar()));
      const botao = faixa.querySelector(".anuncio__pausa");
      if (botao) {
        botao.hidden = false;
        botao.addEventListener("click", () => {
          pausado = !pausado;
          botao.setAttribute("aria-pressed", String(pausado));
          botao.setAttribute("aria-label", pausado ? botao.dataset.rotuloTocar : botao.dataset.rotuloPausar);
          botao.querySelector("[data-icone-pausa]").hidden = pausado;
          botao.querySelector("[data-icone-play]").hidden = !pausado;
          if (pausado) parar();
        });
      }
      tocar();
    }
  }

  /* ── Herói: carrossel ────────────────────────────────────────────────────
     O RELÓGIO É A BARRA. Não há setInterval: o slide avança no `animationend`
     da barra de progresso do ponto ativo. Pausar = `animation-play-state`, e
     a barra retoma de onde parou (um timer recomeçaria do zero).
     Segura (pausa temporária) com o ponteiro em cima, com foco dentro e com a
     aba escondida. A pausa do BOTÃO é da pessoa e só o botão desfaz.
     ⚠️ Movimento reduzido: não toca sozinho. O @media do CSS encurta TODA
     animação pra 0,01 ms; se tocasse, o animationend viria na hora e os slides
     girariam sem parar. */
  const ligarCarrossel = (raizCarrossel) => {
    const c = raizCarrossel.querySelector("[data-carrossel]") || (raizCarrossel.matches && raizCarrossel.matches("[data-carrossel]") ? raizCarrossel : null);
    if (!c || c.dataset.ligado) return;
    c.dataset.ligado = "true";
    const slides = [...c.querySelectorAll(".heroi__slide")];
    // Solta as fotos dos banners 2 e 3 (vcl-estilo.css, "Banners 2 e 3 só baixam depois...").
    const solta = () => (c.closest(".heroi") || c).classList.add("heroi--carregado");
    if (document.readyState === "complete") solta(); else addEventListener("load", solta, { once: true });
    const pontos = [...c.querySelectorAll(".heroi__ponto")];
    const contador = c.querySelector(".heroi__contador");
    const pausa = c.querySelector("[data-pausa]");
    if (slides.length < 2) { c.querySelector(".heroi__controlo")?.setAttribute("hidden", ""); return; }
    let atual = 0;
    const pad = (n) => String(n).padStart(2, "0");
    const ir = (novo) => {
      novo = (novo + slides.length) % slides.length;
      slides.forEach((s, i) => {
        const ativo = i === novo;
        s.dataset.ativo = String(ativo);
        s.toggleAttribute("inert", !ativo);
        s.setAttribute("aria-hidden", String(!ativo));
        [...s.querySelectorAll(".heroi__item")].forEach((el, j) => el.style.setProperty("--i", j));
      });
      pontos.forEach((p, i) => p.setAttribute("aria-current", String(i === novo)));
      // Reinicia a barra: sem isso o navegador não reanima o mesmo elemento.
      const barra = pontos[novo] && pontos[novo].querySelector(".heroi__progresso");
      if (barra) { barra.style.animation = "none"; void barra.offsetWidth; barra.style.animation = ""; }
      if (contador) contador.textContent = `${pad(novo + 1)} / ${pad(slides.length)}`;
      atual = novo;
    };
    const tocar = (sim) => {
      c.dataset.tocando = String(sim && !reduzido());
      if (!pausa) return;
      pausa.setAttribute("aria-pressed", String(!sim));
      pausa.setAttribute("aria-label", sim ? pausa.dataset.rotuloPausar : pausa.dataset.rotuloTocar);
      pausa.querySelector("[data-icone-pausa]").hidden = !sim;
      pausa.querySelector("[data-icone-play]").hidden = sim;
    };
    const segurar = (sim) => (c.dataset.segurando = String(sim));
    pontos.forEach((p, i) => {
      p.addEventListener("click", () => ir(i));
      p.querySelector(".heroi__progresso")?.addEventListener("animationend", () => { if (c.dataset.tocando === "true") ir(atual + 1); });
    });
    c.querySelector("[data-anterior]")?.addEventListener("click", () => ir(atual - 1));
    c.querySelector("[data-proximo]")?.addEventListener("click", () => ir(atual + 1));
    pausa?.addEventListener("click", () => tocar(c.dataset.tocando !== "true"));
    c.addEventListener("pointerenter", (e) => { if (e.pointerType === "mouse") segurar(true); });
    c.addEventListener("pointerleave", () => segurar(false));
    c.addEventListener("focusin", () => segurar(true));
    c.addEventListener("focusout", (e) => { if (!c.contains(e.relatedTarget)) segurar(false); });
    document.addEventListener("visibilitychange", () => segurar(document.hidden));
    c.addEventListener("keydown", (e) => {
      if (!e.target.closest(".heroi__controlo")) return;
      if (e.key === "ArrowRight") { e.preventDefault(); ir(atual + 1); }
      if (e.key === "ArrowLeft") { e.preventDefault(); ir(atual - 1); }
    });
    // Arrastar no celular: só gesto horizontal claro (40px e mais lateral que vertical).
    let x0 = null, y0 = 0;
    c.addEventListener("pointerdown", (e) => { if (e.pointerType !== "mouse") { x0 = e.clientX; y0 = e.clientY; } });
    c.addEventListener("pointerup", (e) => {
      if (x0 === null) return;
      const dx = e.clientX - x0, dy = e.clientY - y0; x0 = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) ir(atual + (dx < 0 ? 1 : -1));
    });
    ir(0);
    tocar(true);
    mq.addEventListener("change", () => tocar(c.dataset.tocando === "true"));
  };
  ligarCarrossel(document);
  document.addEventListener("shopify:section:load", (e) => ligarCarrossel(e.target));

  /* ── Como escolher: abas ─────────────────────────────────────────────────
     Padrão ARIA de tablist: clique ou setas trocam; Home/End vão às pontas.
     Link pra #diametro (menu, rodapé) abre a aba certa antes de rolar. */
  const ligarAbas = (escopo) => {
    escopo.querySelectorAll("[data-abas]").forEach((grupo) => {
      if (grupo.dataset.ligado) return;
      grupo.dataset.ligado = "true";
      const abas = [...grupo.querySelectorAll('[role="tab"]')];
      const abrir = (aba, focar) => {
        abas.forEach((a) => {
          const sim = a === aba;
          a.setAttribute("aria-selected", String(sim));
          a.tabIndex = sim ? 0 : -1;
          const painel = document.getElementById(a.getAttribute("aria-controls"));
          if (painel) painel.hidden = !sim;
        });
        if (focar) aba.focus();
      };
      abas.forEach((a, i) => {
        a.addEventListener("click", () => abrir(a));
        a.addEventListener("keydown", (e) => {
          const n = abas.length;
          const alvo = { ArrowRight: (i + 1) % n, ArrowLeft: (i - 1 + n) % n, Home: 0, End: n - 1 }[e.key];
          if (alvo === undefined) return;
          e.preventDefault(); abrir(abas[alvo], true);
        });
      });
      const porHash = () => {
        const alvo = abas.find((a) => "#" + a.dataset.ancora === location.hash);
        if (alvo) abrir(alvo);
      };
      addEventListener("hashchange", porHash);
      porHash();
    });
  };
  ligarAbas(document);
  document.addEventListener("shopify:section:load", (e) => ligarAbas(e.target));

  /* ── WhatsApp em fila com o chat da Shopify ────────────────────────────────
     18/09/2026, Mateus: "o ícone do WhatsApp está desalinhado". A loja tem o chat
     da Shopify Inbox (app de Johny) no mesmo canto, com margem própria de 20 px, e
     na prévia ele ainda sobe por cima da barra da Shopify: a bola ficava meio por
     baixo do "Conversa". Sem chat, nada muda. Com chat, a bola se alinha pela borda
     direita dele e senta logo acima. O botão do chat é medido, não adivinhado
     (vive num shadow root e aparece depois do load). */
  const whats = document.querySelector(".whats");
  if (whats) {
    const alinha = () => {
      const chat = document.querySelector("shopify-chat")?.shadowRoot?.querySelector(".activator");
      const r = chat?.getBoundingClientRect();
      if (!r || !r.width) { whats.style.removeProperty("--whats-direita"); whats.style.removeProperty("--whats-base"); return false; }
      whats.style.setProperty("--whats-direita", `${Math.round(innerWidth - r.right)}px`);
      whats.style.setProperty("--whats-base", `${Math.round(innerHeight - r.top)}px`);
      return true;
    };
    let tentativas = 0;
    const procura = () => { if (!alinha() && ++tentativas < 8) setTimeout(procura, 750); };
    addEventListener("load", procura);
    new ResizeObserver(() => alinha()).observe(document.documentElement);
  }

  /* ── Flutuantes saem de cima do que importa ──────────────────────────────
     29/09/2026, lista de Johny (item 5): no celular a bola do WhatsApp tapava a ponta do "Adicionar ao carrinho"
     e o link das cabeças de dobra, e o selo do Google (app Google & YouTube) tapava o título do banner. Observa só
     a FAIXA de baixo da tela, onde os dois moram: quando um botão (o de compra, o de cada dobra) ou uma cabeça de dobra passa por ela,
     `flutuantes-fora` esconde os dois (o selo do Google também some com o herói à vista, no CSS). */
  // Fora a barra fixa de compra do celular: ela mora no pé da tela e a bola já senta acima dela.
  // 30/09/2026, Johny: a bola também tapava o texto do "Uso seguro" (`.aviso`) no produto, no celular.
  const sobFlutuante = document.querySelectorAll(".compra .product-form, .compra .aviso, .dobra__cabeca, main .botao:not(.cta-fixo .botao)");
  if (sobFlutuante.length) {
    const naFaixa = new Set();
    let obsFaixa = null;
    const liga = () => {
      if (obsFaixa) obsFaixa.disconnect();
      naFaixa.clear();
      obsFaixa = new IntersectionObserver((entradas) => {
        entradas.forEach((e) => (e.isIntersecting ? naFaixa.add(e.target) : naFaixa.delete(e.target)));
        document.documentElement.classList.toggle("flutuantes-fora", naFaixa.size > 0);
      }, { rootMargin: `-${Math.max(innerHeight - 160, 0)}px 0px 0px 0px`, threshold: 0 });
      sobFlutuante.forEach((el) => obsFaixa.observe(el));
    };
    let altura = innerHeight;
    liga();
    // A faixa depende da altura da tela: religa só quando ela muda (girar o celular), não a cada mudança de conteúdo.
    new ResizeObserver(() => { if (innerHeight !== altura) { altura = innerHeight; liga(); } }).observe(document.documentElement);
  }

  /* ── Produto: erro ao adicionar também na barra fixa do celular ──────────
     O product-form.js do Dawn só preenche o aviso dentro do bloco de compra, que
     some da tela quando a pessoa toca na barra fixa. O espelho é aria-hidden: o
     leitor de tela já ouve o original (role=alert). 21/09/2026, Claude (P-07). */
  document.querySelectorAll(".product-form__error-message-wrapper").forEach((original) => {
    // Só aparece com o botão principal fora da tela (senão o aviso sai duas vezes), e a
    // bola do WhatsApp sai do caminho enquanto ele está lá (cobria o texto no teste).
    const espelho = document.querySelector(".cta-fixo__erro");
    const botao = original.closest("product-form")?.querySelector(".product-form__submit");
    if (!espelho || !botao) return;
    let botaoAVista = false;
    const copia = () => {
      espelho.textContent = original.textContent.trim();
      espelho.hidden = original.hidden || !espelho.textContent || botaoAVista;
      document.documentElement.classList.toggle("erro-no-cta", !espelho.hidden);
    };
    new MutationObserver(copia).observe(original, { attributes: true, childList: true, subtree: true, characterData: true });
    new IntersectionObserver(([e]) => { botaoAVista = e.isIntersecting; copia(); }).observe(botao);
  });

  /* ── Galeria do produto: miniaturas rolam até a foto ────────────────────── */
  document.querySelectorAll("[data-vai-para-foto]").forEach((b) => {
    b.addEventListener("click", () => {
      const alvo = document.getElementById(b.dataset.vaiParaFoto);
      if (alvo) alvo.scrollIntoView({ behavior: reduzido() ? "auto" : "smooth", block: "center" });
    });
  });

  /* ── Diálogos genéricos (filtros da coleção, C-05, 21/09/2026) ──────────
     [data-abre-dialogo="id"] abre o <dialog id>; [data-fecha-dialogo] fecha o seu.
     Clique no fundo (fora da gaveta) também fecha. Esc e foco são do <dialog>. */
  document.querySelectorAll("[data-abre-dialogo]").forEach((b) => b.addEventListener("click", () => document.getElementById(b.dataset.abreDialogo)?.showModal()));
  document.querySelectorAll("[data-fecha-dialogo]").forEach((b) => b.addEventListener("click", () => b.closest("dialog")?.close()));
  document.querySelectorAll("dialog.gaveta-dialogo").forEach((d) => d.addEventListener("click", (e) => { if (e.target === d) d.close(); }));

  /* ── Produto: troca de variante (P-19, 21/09/2026) ─────────────────────
     snippets/vcl-variantes.liquid. Pede a própria seção com a combinação escolhida
     (?option_values=) e copia só os pedaços marcados [data-variante-troca]: preço,
     botão, id da variante, os selects. O resto da página (galeria, zoom) fica. */
  document.querySelectorAll("[data-variantes]").forEach((caixa) => {
    let pedido = 0;
    caixa.addEventListener("change", async () => {
      const ids = [...caixa.querySelectorAll("select")].map((s) => s.selectedOptions[0]?.dataset.optionValueId).filter(Boolean);
      const meu = ++pedido;
      try {
        const r = await fetch(`${caixa.dataset.url}?option_values=${ids.join(",")}&section_id=${caixa.dataset.secao}`);
        if (!r.ok || meu !== pedido) return;
        const novo = new DOMParser().parseFromString(await r.text(), "text/html");
        document.querySelectorAll("[data-variante-troca]").forEach((velho) => {
          const par = novo.querySelector(`[data-variante-troca="${velho.dataset.varianteTroca}"]`);
          if (!par) return;
          if (velho.tagName === "INPUT") velho.value = par.value;
          else velho.innerHTML = par.innerHTML;
          velho.toggleAttribute("disabled", par.hasAttribute("disabled"));
          velho.toggleAttribute("hidden", par.hasAttribute("hidden"));
        });
        const id = novo.querySelector('[data-variante-troca="id"]')?.value;
        if (id) history.replaceState(null, "", `${caixa.dataset.url}?variant=${id}`);
      } catch (_) { /* sem rede: o formulário continua com a variante anterior */ }
    });
  });

  /* ── Produto: zoom da foto (P-04, 21/09/2026) ───────────────────────────
     <dialog> nativo faz foco preso, Esc e devolução de foco. Aqui: abrir na foto
     clicada, setas/teclado, contador, e aproximar no ponto (arrastar move). */
  /* Vídeo da galeria (20/10/2026, Johny): mudo e em loop, mas só toca o que está à vista, pra não
     baixar e rodar vários de uma vez na coluna do computador. Com movimento reduzido, não toca
     sozinho: para e ganha controles. */
  const videos = document.querySelectorAll("video.galeria__video");
  if (videos.length) {
    if (reduzido()) {
      videos.forEach((v) => { v.removeAttribute("autoplay"); v.pause(); v.controls = true; });
    } else {
      const tela = new IntersectionObserver((es) => es.forEach((e) => {
        if (e.isIntersecting) e.target.play().catch(() => {});
        else e.target.pause();
      }), { threshold: 0.4 });
      videos.forEach((v) => tela.observe(v));
    }
  }

  const zoom = document.querySelector(".zoom");
  if (zoom) {
    const trilho = zoom.querySelector(".zoom__trilho");
    const fotos = [...zoom.querySelectorAll(".zoom__foto")];
    const contador = zoom.querySelector(".zoom__contador");
    let atual = 0;
    const afasta = () => fotos.forEach((f) => f.classList.remove("zoom__foto--perto"));
    const vai = (i, suave) => {
      atual = (i + fotos.length) % fotos.length;
      afasta();
      trilho.scrollTo({ left: fotos[atual].offsetLeft, behavior: suave && !reduzido() ? "smooth" : "auto" });
    };
    const vista = new IntersectionObserver((es) => es.forEach((e) => {
      if (!e.isIntersecting) return;
      atual = fotos.indexOf(e.target);
      if (contador) contador.textContent = `${atual + 1} / ${fotos.length}`;
    }), { root: trilho, threshold: 0.6 });
    fotos.forEach((f) => vista.observe(f));
    document.querySelectorAll("[data-amplia]").forEach((b) => b.addEventListener("click", () => {
      zoom.showModal();
      vai(Number(b.dataset.amplia) || 0, false);
    }));
    zoom.querySelectorAll("[data-zoom-passo]").forEach((b) => b.addEventListener("click", () => vai(atual + Number(b.dataset.zoomPasso), true)));
    zoom.querySelector("[data-fecha-zoom]")?.addEventListener("click", () => zoom.close());
    zoom.addEventListener("close", afasta);
    zoom.addEventListener("keydown", (e) => {
      if (fotos.length < 2) return;
      if (e.key === "ArrowRight") { e.preventDefault(); vai(atual + 1, true); }
      if (e.key === "ArrowLeft") { e.preventDefault(); vai(atual - 1, true); }
    });
    const mira = (foto, e) => {
      const r = foto.getBoundingClientRect();
      foto.querySelector("img").style.transformOrigin = `${((e.clientX - r.left) / r.width) * 100}% ${((e.clientY - r.top) / r.height) * 100}%`;
    };
    fotos.forEach((foto) => {
      const imagem = foto.querySelector("img");
      imagem.addEventListener("click", (e) => { mira(foto, e); foto.classList.toggle("zoom__foto--perto"); });
      imagem.addEventListener("pointermove", (e) => { if (foto.classList.contains("zoom__foto--perto")) mira(foto, e); });
    });
  }

  // Data-limite do Halloween (snippets/vcl-prazo-halloween.liquid, 06/10/2026). A página pode vir do cache da Shopify
  // com a fase de outro dia: confere a data de hoje no fuso da loja e troca o texto, ou tira a linha depois do último limite.
  document.querySelectorAll("[data-prazo-halloween]").forEach((linha) => {
    let hoje;
    try { hoje = Number(new Intl.DateTimeFormat("en-CA", { timeZone: linha.dataset.fuso, year: "numeric", month: "2-digit", day: "2-digit" }).format(new Date()).replace(/-/g, "")); } catch { return; }
    const fase = ["a", "b", "c"][linha.dataset.limites.split(",").map(Number).findIndex((limite) => hoje <= limite)];
    if (!fase) { linha.hidden = true; return; }
    linha.querySelector("[data-prazo-texto]").textContent = linha.dataset[`texto${fase.toUpperCase()}`];
    linha.hidden = false;
  });

  // Newsletter enviada (H-08, 21/09/2026): a Shopify volta pra #NewsletterForm, mas imagens que carregam
  // depois do salto tiravam o aviso da tela. Depois do load, centraliza o formulário com o aviso.
  // Formulários 'customer' dividem o mesmo estado na Shopify: a inscrição feita num aparece como resultado
  // em todos. Só o formulário da âncora (#Id) mostra o aviso; os outros voltam ao normal (25/09/2026).
  ["NewsletterForm", "BoasVindasForm"].forEach((id) => {
    if (location.hash === `#${id}`) return;
    document.getElementById(id)?.querySelectorAll(".campo__ok, .campo__erro").forEach((m) => m.remove());
  });
  addEventListener("load", () => {
    const form = location.hash === "#NewsletterForm" ? document.getElementById("NewsletterForm") : null;
    if (form?.querySelector(".campo__ok, .campo__erro")) form.scrollIntoView({ block: "center", behavior: "instant" });
  }, { once: true });

  // Pop-up de boas-vindas (G-16, 22/09/2026). Abre uma vez depois do atraso; fechar guarda 30 dias.
  // Volta de uma inscrição (#BoasVindasForm com resultado): abre na hora pra mostrar o código ou o erro.
  // Resultado vindo de outro formulário (newsletter da home): o pop-up não abre nesta visita (25/09/2026).
  // Consentimento (25/09/2026): não abre por cima do banner de cookies (Pandectes). Enquanto a pessoa não
  // escolheu, espera; quando escolhe (visitorConsentCollected / PandectesEvent_OnConsent), abre 8 s depois.
  const boasVindas = document.querySelector("[data-boas-vindas]");
  if (boasVindas) {
    const CHAVE = "vcl-boas-vindas";
    const lembra = () => { try { localStorage.setItem(CHAVE, String(Date.now())); } catch {} };
    const visto = () => { try { return Date.now() - Number(localStorage.getItem(CHAVE) || 0) < 30 * 864e5; } catch { return false; } };
    const visivel = (el) => { if (!el || el.hidden) return false; const c = getComputedStyle(el); return c.display !== "none" && c.visibility !== "hidden" && Number(c.opacity) > 0 && el.getClientRects().length > 0; };
    const bannerAberto = () => [...document.querySelectorAll('#pandectes-banner, [id*="pandectes" i][role="dialog"], [class*="pandectes" i][role="dialog"], [id*="pandectes" i][aria-modal="true"], [class*="pandectes" i][aria-modal="true"], #shopify-pc__banner')].some(visivel);
    let pediuApi = false;
    const semEscolha = () => {
      if (bannerAberto()) return true;
      const p = window.Shopify?.customerPrivacy;
      if (!p) {
        if (!pediuApi && window.Shopify?.loadFeatures) { pediuApi = true; window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], () => {}); return true; }
        return false;
      }
      try {
        if (document.cookie.includes("_pandectes_gdpr=")) return false;
        if (typeof p.shouldShowBanner === "function" && !p.shouldShowBanner()) return false;
        const c = typeof p.currentVisitorConsent === "function" ? p.currentVisitorConsent() : null;
        return c ? ["marketing", "analytics", "preferences"].every((k) => !c[k]) : false;
      } catch { return false; }
    };
    // Não interrompe: com busca, menu, gaveta ou outra janela aberta, ou com a pessoa digitando, tenta de novo em 6 s.
    const ocupada = () => document.querySelector("dialog[open], details[open] > .search-modal, cart-drawer.active, .painel-mascara[data-aberto='true'], .menu-mobile[data-aberto='true']") || document.activeElement?.matches("input, textarea, select");
    let esperaConsentimento = false, relogio = 0;
    const agenda = (ms) => { clearTimeout(relogio); relogio = setTimeout(abre, ms); };
    const abre = () => {
      if (boasVindas.open || visto()) return;
      if (semEscolha()) { esperaConsentimento = true; agenda(6000); return; }
      if (ocupada()) { agenda(6000); return; }
      boasVindas.showModal();
    };
    const escolheu = (e) => {
      if (e?.type === "PandectesEvent_OnConsent" && !["new", "stored", "revoke"].includes(e.detail?.consentType ?? e.consentType)) return;
      if (esperaConsentimento) { esperaConsentimento = false; agenda(8000); }
    };
    document.addEventListener("visitorConsentCollected", escolheu);
    addEventListener("PandectesEvent_OnConsent", escolheu);
    boasVindas.addEventListener("close", lembra);
    boasVindas.addEventListener("click", (e) => { if (e.target === boasVindas || e.target.closest("[data-fecha-boas-vindas]")) boasVindas.close(); });
    const resultado = boasVindas.querySelector("[data-boas-vindas-ok]");
    if (resultado && location.hash === "#BoasVindasForm") { lembra(); boasVindas.showModal(); }
    else if (resultado) { if (boasVindas.querySelector("h2[data-boas-vindas-ok]")) lembra(); }
    else if (!visto()) agenda(Number(boasVindas.dataset.atraso || 8) * 1000);
  }

  // Cupom no carrinho (K-09, 22/09/2026, Mateus). /cart/update.js aceita "discount" (códigos separados por
  // vírgula) e responde com discount_codes[].applicable. Código que não vale: mostra o erro e sai da lista.
  // Depois redesenha a gaveta (.drawer__inner) ou o /cart (cart-items) com a própria seção.
  const redesenhaCarrinho = async () => {
    const pagina = document.getElementById("main-cart-items");
    const secao = pagina ? pagina.dataset.id : "cart-drawer";
    const alvo = pagina ? "cart-items" : "#CartDrawer .drawer__inner";
    const html = await (await fetch(`${window.routes.cart_url}?section_id=${secao}`)).text();
    const novo = new DOMParser().parseFromString(html, "text/html").querySelector(alvo);
    const velho = document.querySelector(alvo);
    if (novo && velho) velho.innerHTML = novo.innerHTML;
  };
  const mandaCupons = async (codigos) => {
    const r = await fetch(`${window.routes.cart_update_url}.js`, { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ discount: codigos.join(",") }) });
    return r.json();
  };
  const cuponsValidos = async () => ((await (await fetch(`${window.routes.cart_url}.js`)).json()).discount_codes || []).filter((d) => d.applicable).map((d) => d.code);
  document.addEventListener("submit", async (e) => {
    const form = e.target.closest("[data-cupom]");
    if (!form) return;
    e.preventDefault();
    const codigo = form.elements.cupom.value.trim();
    const erro = form.querySelector("[data-cupom-erro]");
    if (!codigo) { form.elements.cupom.focus(); return; }
    form.setAttribute("aria-busy", "true");
    erro.hidden = true;
    try {
      const atuais = (await cuponsValidos()).filter((c) => c.toLowerCase() !== codigo.toLowerCase());
      const carrinho = await mandaCupons([...atuais, codigo]);
      const vale = (carrinho.discount_codes || []).some((d) => d.code.toLowerCase() === codigo.toLowerCase() && d.applicable);
      if (!vale) {
        await mandaCupons(atuais);
        form.removeAttribute("aria-busy");
        erro.hidden = false;
        form.elements.cupom.select();
        return;
      }
      await redesenhaCarrinho();
    } catch {
      form.removeAttribute("aria-busy");
      erro.hidden = false;
    }
  });
  document.addEventListener("click", async (e) => {
    const botao = e.target.closest("[data-cupom-tirar]");
    if (!botao) return;
    const form = botao.closest("[data-cupom]");
    const erro = form.querySelector("[data-cupom-erro]");
    form.setAttribute("aria-busy", "true");
    if (erro) erro.hidden = true;
    try {
      const fica = (await cuponsValidos()).filter((c) => c.toLowerCase() !== botao.dataset.cupomTirar.toLowerCase());
      await mandaCupons(fica);
      await redesenhaCarrinho();
    } catch {
      form.removeAttribute("aria-busy");
      if (erro) erro.hidden = false;
    }
  });

  // Idioma e país (snippets/vcl-localizacao.liquid): escolher no <select> já troca. 21/09/2026.
  document.addEventListener("change", (e) => {
    const campo = e.target.closest(".localizacao select");
    if (campo) campo.form.submit();
  });
})();
